// ============================================================================
// BonBoZ: menu con của trang Cài đặt và trang Báo cáo.
//
// Trước đây các mục con này nằm trong thanh trái — nghĩa là thanh trái vừa
// phải phục vụ người đang trực page (lọc hội thoại), vừa phải chứa hai chục mục
// quản trị. Giờ mỗi trang tự mang menu của nó, đúng cách Retion và Pancake làm:
// thanh trên chọn phần lớn, vào trong phần nào thì phần đó có menu riêng.
//
// `toi` là TÊN ROUTE. Có route chỉ tồn tại ở bản trả phí (audit log, SLA...),
// nên component hiển thị lọc lại bằng `router.hasRoute()` — thiếu bước đó thì
// một tên route không tồn tại đủ làm cả trang ném lỗi khi dựng liên kết.
// `nhan` là khoá dịch, dùng lại đúng khoá của Chatwoot để không phải dịch lại.
//
// Thứ tự và cách gom nhóm dưới đây bám theo cây Cài đặt của Pancake
// (docs.pancake.biz/pancake/st-f7), vì đội trực page đến từ Pancake và tìm
// theo trí nhớ cũ. Ba mục đổi tên cho khớp Pancake: Hộp thư đến → Cài đặt
// trang, Nhãn → Thẻ hội thoại, Câu trả lời mẫu → Hỗ trợ trả lời. Đổi ở khoá
// dịch riêng của BonBoZ, không sửa file locale của Chatwoot.
//
// Mục có `nhom` là tiêu đề nhóm, không phải liên kết — nó không có `toi`.
// ============================================================================

/**
 * Bỏ mục không hiển thị được, rồi bỏ nốt tiêu đề nhóm đã rỗng.
 *
 * `hienDuoc` nhận cả mục chứ không chỉ tên route, vì còn phải tra `meta` của
 * route (feature flag, permission, installationTypes) — xem SETUP.md.
 *
 * @param {Array} muc phần tử có `nhom` là tiêu đề nhóm
 * @param {(m: object) => boolean} hienDuoc
 */
export function locMucHienDuoc(muc, hienDuoc) {
  const giu = muc.filter(m => m.nhom || hienDuoc(m));
  return giu.filter((m, i) => !m.nhom || (giu[i + 1] && !giu[i + 1].nhom));
}

// Xem chú thích tại mục Phân công hội thoại bên dưới.
const HIEN_PHAN_CONG = false;

export const MENU_CAI_DAT = [
  // Chatwoot gốc chỉ cho vào Cài đặt cá nhân qua menu avatar; đang đứng trong
  // Cài đặt mà muốn qua mục cá nhân phải quay ra ngoài. Pancake đặt nó ngay
  // trong danh sách này và người dùng cũng tìm ở đây trước. Để đầu vì đây là
  // mục ai cũng dùng được, các nhóm dưới phần lớn là của quản trị.
  { nhom: 'BONBOZ.MENU_CAI_DAT.NHOM_CA_NHAN' },
  {
    toi: 'profile_settings_index',
    nhan: 'SIDEBAR_ITEMS.PROFILE_SETTINGS',
    icon: 'i-lucide-user-cog',
  },

  { nhom: 'BONBOZ.MENU_CAI_DAT.NHOM_TRANG' },
  {
    toi: 'settings_inbox_list',
    nhan: 'BONBOZ.MENU_CAI_DAT.CAI_DAT_TRANG',
    icon: 'i-lucide-inbox',
  },
  {
    toi: 'labels_list',
    nhan: 'BONBOZ.MENU_CAI_DAT.THE_HOI_THOAI',
    icon: 'i-lucide-tags',
  },
  // `bonboz_tag_trang_index` cố tình KHÔNG có ở đây: phần tick thẻ theo trang
  // đã nằm ngay dưới kho thẻ trong mục trên. Route vẫn còn cho link cũ.
  {
    toi: 'canned_list',
    nhan: 'BONBOZ.MENU_CAI_DAT.HO_TRO_TRA_LOI',
    icon: 'i-lucide-message-square-quote',
  },
  // Tương đương tab "Giao diện" của Pancake: màu nhận diện của từng trang.
  // Ở nhóm Trang vì nó là cấu hình THEO TRANG, cùng cái bag `mau_tra_loi`.
  {
    toi: 'bonboz_page_appearance_index',
    nhan: 'BONBOZ.MENU_CAI_DAT.GIAO_DIEN',
    icon: 'i-lucide-monitor',
  },

  { nhom: 'BONBOZ.MENU_CAI_DAT.NHOM_DOI_NGU' },
  { toi: 'agent_list', nhan: 'SIDEBAR.AGENTS', icon: 'i-lucide-square-user' },
  { toi: 'settings_teams_list', nhan: 'SIDEBAR.TEAMS', icon: 'i-lucide-users' },
  // Tương đương "Chế độ xoay vòng" của Pancake; route và UI có sẵn từ đầu.
  // TẠM ẨN (cờ `HIEN_PHAN_CONG`): phân công tự động đã tắt hẳn ở Rails
  // (concern BonbozTatPhanCong), để mục này thì người ta bật mà không thấy gì
  // xảy ra. Bật lại phân công thì lật cờ, mục quay về đúng chỗ.
  ...(HIEN_PHAN_CONG
    ? [
        {
          toi: 'assignment_policy_index',
          nhan: 'BONBOZ.MENU_CAI_DAT.PHAN_CONG',
          icon: 'i-lucide-shuffle',
        },
      ]
    : []),

  { nhom: 'BONBOZ.MENU_CAI_DAT.NHOM_TU_DONG' },
  {
    toi: 'automation_list',
    nhan: 'BONBOZ.MENU_CAI_DAT.QUY_TAC_TU_DONG',
    icon: 'i-lucide-repeat',
  },
  { toi: 'macros_wrapper', nhan: 'SIDEBAR.MACROS', icon: 'i-lucide-toy-brick' },
  { toi: 'agent_bots', nhan: 'SIDEBAR.AGENT_BOTS', icon: 'i-lucide-bot' },

  { nhom: 'BONBOZ.MENU_CAI_DAT.NHOM_KET_NOI' },
  {
    toi: 'settings_applications',
    nhan: 'SIDEBAR.INTEGRATIONS',
    icon: 'i-lucide-blocks',
  },
  // Kéo lên cấp 1 vì đây là cách `crm/` và sau này `chatbot/` nhận sự kiện.
  {
    toi: 'settings_integrations_webhook',
    nhan: 'BONBOZ.MENU_CAI_DAT.WEBHOOK',
    icon: 'i-lucide-webhook',
  },

  { nhom: 'BONBOZ.MENU_CAI_DAT.NHOM_HE_THONG' },
  {
    toi: 'general_settings_index',
    nhan: 'SIDEBAR.ACCOUNT_SETTINGS',
    icon: 'i-lucide-briefcase',
  },
  // Không còn "sắp bỏ": dữ liệu quảng cáo và Epoint đều nằm ở
  // `custom_attributes`, khai ở đây mới lọc được.
  {
    toi: 'attributes_list',
    nhan: 'SIDEBAR.CUSTOM_ATTRIBUTES',
    icon: 'i-lucide-code',
  },

  // Bỏ `security_settings_index` và `auditlogs_list`: cả hai khai
  // `installationTypes: [CLOUD, ENTERPRISE]`, bản community không mở được.
];

// ICON LAY THEO PANCAKE, tung muc mot: duong nhip tim cho Tong quan, la co cho
// Trang, nhom nguoi cho Nhan vien, the cho Thu hoi thoai, loa cho Quang cao.
// Nguoi dung da quen bo icon do o Pancake nen doi sang bo khac la bat ho hoc
// lai mot thu khong co gi hay hon.
export const MENU_BAO_CAO = [
  {
    toi: 'account_overview_reports',
    nhan: 'SIDEBAR.REPORTS_OVERVIEW',
    icon: 'i-lucide-activity',
  },
  // Bon muc, moi muc mot cau hoi khac han nhau: ca nha / tung trang / tung
  // nguoi / tung the. Truoc day co bay muc va ba trong so do noi cung mot thu:
  //
  //   "Hoi thoai" = 7 the so toan nha       -> gop vao Trang
  //   "Hop thu"   = van nhung the so do,    -> gop vao Trang (phong kham co
  //                 tach theo hop thu          dung hai hop thu va ca hai deu
  //                                            la mot trang Facebook: "hop thu"
  //                                            va "trang" la mot, chi khac chu)
  //   "Pheu theo trang"                     -> gop vao Trang
  //
  // "Nhom" da bo han: do tren may that co 0 nhom, 0 thanh vien va 0/145 hoi
  // thoai gan nhom. Trang do khong the hien gi ngoai trang rong.
  {
    toi: 'conversation_reports',
    nhan: 'BONBOZ.TRANG_TK.TIEU_DE',
    icon: 'i-lucide-flag',
  },
  {
    toi: 'agent_reports_index',
    nhan: 'SIDEBAR.REPORTS_AGENT',
    icon: 'i-lucide-users',
  },
  {
    toi: 'bonboz_tuong_tac',
    nhan: 'BONBOZ.TUONG_TAC.TIEU_DE',
    icon: 'i-lucide-message-square',
  },
  {
    toi: 'label_reports_index',
    nhan: 'SIDEBAR.REPORTS_LABEL',
    icon: 'i-lucide-tag',
  },
  {
    toi: 'bonboz_tong_dai',
    nhan: 'BONBOZ.TONG_DAI.TIEU_DE',
    icon: 'i-lucide-phone',
  },
  {
    toi: 'bonboz_quang_cao',
    nhan: 'BONBOZ.QUANG_CAO.TIEU_DE',
    icon: 'i-lucide-megaphone',
  },
  {
    toi: 'bonboz_danh_gia',
    nhan: 'BONBOZ.DANH_GIA.TIEU_DE',
    icon: 'i-lucide-star',
  },
  {
    toi: 'bonboz_cam_xuc',
    nhan: 'BONBOZ.CAM_XUC.TIEU_DE',
    icon: 'i-lucide-smile',
  },
  {
    toi: 'bonboz_sao_luu',
    nhan: 'BONBOZ.SAO_LUU.TIEU_DE',
    icon: 'i-lucide-history',
  },
  {
    toi: 'bonboz_push_report',
    nhan: 'BONBOZ.PUSH_REPORT.TITLE',
    icon: 'i-lucide-bell-ring',
  },
];
